import { CurrentUserApi } from '@antegma/accallio-cloud-profile-api'
import { getEnv } from 'App/util/env'
import { Api } from '../../api'

type TEnv = {
  PROFILE_API_BASE_PATH: string
}

const env = getEnv<TEnv>({
  PROFILE_API_BASE_PATH: process.env.REACT_APP_PROFILE_API_BASE_PATH || 'https://profile-api.accallio.com',
})

const currentUserApi = new CurrentUserApi(undefined, env.PROFILE_API_BASE_PATH, Api.instance.axiosInstance)


// Export APIs
export default {
  currentUserApi,
}
